import React from 'react';
import { AdaptedApiTeam, AdaptedApiTeamMemberTrainingSummary, ApiTeamMemberTrainingSummary } from './CourseTeams.types';
import { Label } from '../../../common/Label/Label';
import { TABLE_LABELS } from '../../../../lib/constants/labelKeys';
import PureTable from '../../../common/PureTable/PureTable';
import { PureTableActionBaseHandler } from '../../../common/PureTable/PureTable.types';
import ExtendedTableActions from '../../../common/PureTable/ExtendedTableActions';
import CardBadge from '../CourseCard/CardBadge';
import { getTrainingStatusKey } from '../TableManager/TableManager.utils';
import styles from './CourseTeams.module.scss';
import { Api } from '../../../../lib/types/apiSpec';

export const teamsAdapter =
  (teamsAwaitingDelete: { [teamid: string]: boolean }) =>
  ({
    actionHandler,
    hideOverdue,
    reportEnabled = false,
    previewEnabled = false,
  }: {
    actionHandler: PureTableActionBaseHandler;
    hideOverdue: boolean;
    reportEnabled: boolean;
    previewEnabled: boolean;
  }) =>
  ({ id = '', totalOverdue, ...rest }: Api.CourseTeamSummary): AdaptedApiTeam => ({
    id,
    ...(hideOverdue
      ? null
      : {
          totalOverdue: totalOverdue ? (
            <PureTable.Badge key={`overdue|${totalOverdue}`}>{totalOverdue}</PureTable.Badge>
          ) : (
            <Label name={TABLE_LABELS.VALUE_NOT_AVAILABLE} />
          ),
        }),
    removeTeam: !teamsAwaitingDelete[id] ? (
      <ExtendedTableActions
        id={id}
        actions={[
          { type: 'delete.team', action: () => actionHandler({ type: 'delete.team', id }) },
          ...(reportEnabled
            ? [
                {
                  type: 'download.teamTrainingMembers' as const,
                  action: () => actionHandler({ type: 'download.teamTrainingMembers', id }),
                },
              ]
            : []),
          ...(previewEnabled
            ? [
                {
                  type: 'openDetails.teamTrainingMembers' as const,
                  action: () => actionHandler({ type: 'openDetails.teamTrainingMembers', id }),
                },
              ]
            : []),
        ]}
      />
    ) : (
      <PureTable.Loader key={`loader-delete-${id}`} />
    ),
    ...rest,
  });
export const teamMemberAdapter = ({
  firstName,
  lastName,
  userName,
  status,
  completed,
  ...rest
}: ApiTeamMemberTrainingSummary): AdaptedApiTeamMemberTrainingSummary => {
  return {
    ...rest,
    fullName: `${firstName} ${lastName}`,
    userName,
    status: (
      <CardBadge
        className={styles.teamMemberBadge}
        key={getTrainingStatusKey(status)}
        status={status}
        withNotStartedBadge
      />
    ),
  };
};
